<script lang="ts" setup>
withDefaults(
    defineProps<{
        size?: 'sm' | 'md' | 'lg'
    }>(),
    {
        size: 'lg',
    },
)
</script>

<template>
    <div class="group cursor-pointer select-none">
        <h1
            class="font-bold text-dark-500 dark:text-dark-200 mb-2 transition-all duration-500 group-hover:text-yellow-500 group-hover:drop-shadow-2xl"
            :class="{
                'text-3xl': size === 'sm',
                'text-4xl': size === 'md',
                'text-6xl': size === 'lg',
            }"
        >
            <span
                v-for="(letter, index) in 'Livrero'.split('')"
                :key="index"
                class="logo-letter transition-all duration-300 ease-out inline-block group-hover:animate-logo-bounce group-hover:text-yellow-500"
                :style="{ animationDelay: index * 100 + 'ms' }"
                v-text="letter"
            />
        </h1>

        <div
            class="h-1 bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-full transition-all duration-700 group-hover:h-2 group-hover:shadow-lg group-hover:shadow-yellow-500/50 group-hover:animate-pulse"
            :class="{
                'w-16 group-hover:w-24': size === 'sm',
                'w-24 group-hover:w-36': size === 'md',
                'w-32 group-hover:w-48': size === 'lg',
            }"
        />
    </div>
</template>

<style scoped>
@keyframes logo-bounce {
    0%,
    100% {
        transform: translateY(0) scale(1);
        text-shadow: 0 0 0 rgba(255, 209, 40, 0);
    }
    25% {
        transform: translateY(-8px) scale(1.1);
        text-shadow: 0 4px 8px rgba(255, 209, 40, 0.3);
    }
    50% {
        transform: translateY(-12px) scale(1.15);
        text-shadow: 0 8px 16px rgba(255, 209, 40, 0.4);
    }
    75% {
        transform: translateY(-6px) scale(1.05);
        text-shadow: 0 6px 12px rgba(255, 209, 40, 0.3);
    }
}

.animate-logo-bounce {
    animation: logo-bounce 0.8s ease-out;
}
</style>
